/**
 * Parses query parameters from a URL into an object.
 * If no URL is provided, it uses the current window's URL.
 * 
 * @param {string} [url] - URL to read query parameters from.
 * @returns {Object} An object containing query parameters.
 */
export function getUrlParams(url) {
    const params = {};

    const query = (url ? (new URL(url)).search : window?.location?.search) ?? null;
    if (!query) {
        return params;
    }

    for (const [key, value] of new URLSearchParams(window.location.search)) {
        params[key.toLowerCase()] = value;
    }

    return params;
}